export enum RecordingType {
	ASYNC = "async",
	EDEN = "eden",
	ARK = "ark",
	BUILD = "build"
}
